export default "__VITE_ASSET__DYLDnzoT__"